import request from "./request";

const AuthService = {
  login: async (loginDto: LoginDto): Promise<any> => {
    return await request({
      method: "post",
      baseURL: `${process.env.REACT_APP_API_URL}/auth/sign-in`,
      data: loginDto,
    });
  },
  signUp: async (signUpDto: SignUpDto): Promise<any> => {
    return await request({
      method: "post",
      baseURL: `${process.env.REACT_APP_API_URL}/auth/register`,
      data: signUpDto,
    });
  },
  signOut: async (email: string): Promise<any> => {
    return await request({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/sign-out`,
      data: { email },
    });
  },
  resendLink: async (email: string): Promise<any> => {
    return await request({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/resend-code`,
      data: { email },
    });
  },
  initiateResetPassword: async (email: string): Promise<any> => {
    return await request({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
      data: { email },
    });
  },
  CompletePasswordChange: async (
    email: string,
    code: string,
    newPassword: string
  ): Promise<any> => {
    return await request({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/confirm-password`,
      data: { email, code, newPassword },
    });
  },
  getUserFromToken: async (): Promise<any> => {
    return await request({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/auth/user-from-token`,
    });
  },
  editProfileData: async (
    email: string,
    name: string,
    phoneNumber: string,
    lastName: string,
    companyName: string
  ): Promise<any> => {
    return await request({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/auth/edit-profile`,
      data: { email, name, phoneNumber, lastName, companyName },
    });
  },
  refreshToken: async (refreshToken: string, email: string): Promise<any> => {
    return await request({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
      data: {
        refreshToken,
        email,
      },
    });
  },
};

export { AuthService };
